import {Swiper} from 'swiper'

// media and content slider
let mediaContentSlider = $('.js-media-content-slider')
if (mediaContentSlider.length){

  mediaContentSlider.each((i, el)=> {

    let sliderC = $(el).closest('.js-block')
    let imagesSlider = sliderC.find('.js-media-content-slider-images')
    let curSlide = sliderC.find('.js-current-slide')
    let nextB = sliderC.find('.js-next-slide')
    let prevB = sliderC.find('.js-prev-slide')

    let autoHeight = false
    if ($(window).innerWidth() < 1200) autoHeight = true

    let swiper = new Swiper(el, {
      loop: true,
      effect: "fade",
      speed: 400,
      autoHeight: autoHeight,
      autoplay: {
        delay: 5000,
      },
    });

    let imageSwiper = new Swiper(imagesSlider[0], {
      loop: true,
      //effect: "fade",
      //mousewheel: true,
      speed: 1000,
      // speed: 400
    });

    imageSwiper.controller.control = swiper
    swiper.controller.control = imageSwiper

    // navigation buttons
    nextB.click(()=> swiper.slideNext() )
    prevB.click(()=> swiper.slidePrev() )

    // slide change event
    swiper.on('slideChange', (slider)=> {
      curSlide.text(slider.realIndex + 1)
    });






  })

}
